import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import CheckCSName from "../CheckCSName";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import SuperText from "../SuperText";
import ResultView from "../../../components/ResultView";

export function B40({data, message_key}) {
    const {settings} = useUser()
    let result = [...(data?.result || [])]
    result.reverse()

    return (
        <>
            {
                result.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables}/>
                    </ResultView>
                ))
            }
        </>
    )
}

export const BridgeTable = ({r}) => {
    return (
        <>
            <ResultTable maxWidth={HecRasHelper.getWidth(50)}>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell rowSpan={2} style={{
                            width: HecRasHelper.getWidth(20),
                            textAlign: 'left',
                            verticalAlign: 'start'
                        }}>
                            Bridge<br/>
                            RS <CheckCSName csName={r.cross_section} csNameVal={r.cross_section} />
                        </ResultHeaderCell>
                        <ResultHeaderCell colSpan={2}>US</ResultHeaderCell>
                        <ResultHeaderCell colSpan={2}>DS</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            width: HecRasHelper.getWidth(10)
                        }}>Left</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            width: HecRasHelper.getWidth(10)
                        }}>Right</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            width: HecRasHelper.getWidth(10)
                        }}>Left</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            width: HecRasHelper.getWidth(10),
                        }}>Right</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    <ResultRow>
                        <ResultBodyCell>Thalweg Sta</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.up_thalweg[0]?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.down_thalweg[0]?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Thalweg Elev</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.up_thalweg[1]?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.down_thalweg[1]?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Bank Sta</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_bank_left?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_bank_right?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_bank_left?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_bank_right?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Bank Elev</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_bank_left_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_bank_right_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_bank_left_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_bank_right_elev?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Ineff Sta</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>
                            <SuperText text={r.up_left_xs_footnote}/>
                            {r.up_left_xs_station?.toString() || '-'}
                        </ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>
                            <SuperText text={r.up_right_xs_footnote}/>
                            {r.up_right_xs_station?.toString() || '-'}
                        </ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>
                            <SuperText text={r.down_left_xs_footnote}/>
                            {r.down_left_xs_station?.toString() || '-'}
                        </ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>
                            <SuperText text={r.down_right_xs_footnote}/>
                            {r.down_right_xs_station?.toString() || '-'}
                        </ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Ineff Elev</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.up_left_xs_elevation?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.up_right_xs_elevation?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.down_left_xs_elevation?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.down_right_xs_elevation?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Opening Sta</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.up_left_opening_station?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.up_right_opening_station?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.down_left_opening_station?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.down_right_opening_station?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Distance To XS</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{parseFloat(r?.dist_to_xs)?.toFixed(2) || '-'}</ResultBodyCell>
                        <ResultHeaderCell style={{color: 'orange', textAlign: 'right'}}
                                          colSpan={2}>{parseFloat(r?.down_dist)?.toFixed(2) || '-'}</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Bridge Width</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={4}>{r?.bridge_us_width?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Dist. Btw XS</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={4}>{r?.up_dist_btw_xs?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Expansion Width</ResultBodyCell>
                        <ResultHeaderCell style={{
                            color: 'orange',
                            textAlign: 'right'
                        }}>{r?.up_left_diff?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            color: 'orange',
                            textAlign: 'right'
                        }}>{r?.up_right_diff?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            color: 'orange',
                            textAlign: 'right'
                        }}>{r?.down_left_diff?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            color: 'orange',
                            textAlign: 'right'
                        }}>{r?.down_right_diff?.toString() || '-'}</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Low Chord Elev</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_left_low_chord_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_right_low_chord_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_left_low_chord_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_right_low_chord_elev?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>High Chord Elev</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.ulr_high_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.urr_high_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.dlr_high_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.drr_high_elev?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>High Chord Sta</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.ulr_high_sta?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.urr_high_sta?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.dlr_high_sta?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.drr_high_sta?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Top of Rail Elev</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.ulr_top_rail?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.urr_top_rail?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.dlr_top_rail?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.drr_top_rail?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Rail Height</ResultBodyCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.ulr_rail_height?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.urr_rail_height?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.dlr_rail_height?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.drr_rail_height?.toString() || '-'}</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Cont/Exp Ratio</ResultBodyCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.up_left_ratio?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.up_right_ratio?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.down_left_ratio?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.down_right_ratio?.toString() || '-'}</ResultHeaderCell>
                    </ResultRow>
                </ResultBody>
            </ResultTable>
            <div>
                <ResultText>
                    Skew: {r?.skew}, Map Skew: {parseInt(r?.skew_map)}
                </ResultText>
            </div>
        </>
    )
}


export const CulvertTable = ({r}) => {
    const culverts = []
    r?.culverts?.forEach(c => {
        const barrels = []
        c?.barrels?.forEach(b => {
            barrels.push(
                <ResultRow>
                    <ResultBodyCell style={{textAlign: 'start'}}>{b?.name} Centerline Sta</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{b?.us || '-'}</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{b?.ds || '-'}</ResultBodyCell>
                </ResultRow>
            )
        })

        culverts.push(
            <>
                <ResultRow>
                    <ResultHeaderCell colSpan={5}>{c?.name}</ResultHeaderCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell style={{textAlign: 'start'}}>Distance To XS</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{parseFloat(c?.us_dist_to_xs)?.toFixed(2) || '-'}</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{parseFloat(c?.ds_dist_to_xs)?.toFixed(2) || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell style={{textAlign: 'start'}}>Culvert Length</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={4}>{c?.culvert_length || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell style={{textAlign: 'start'}}>Invert Elev</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{c?.us_invert_elev || '-'}</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{c?.ds_invert_elev || '-'}</ResultBodyCell>
                </ResultRow>
                {barrels}
            </>
        )
    })

    return (
        <ResultTable style={{maxWidth: HecRasHelper.getWidth(54)}}>
            <ResultHeader>
                <ResultRow>
                    <ResultHeaderCell rowSpan={2} style={{
                        width: HecRasHelper.getWidth(22),
                        textAlign: 'left',
                        verticalAlign: 'start'
                    }}>
                        Culvert Group<br/>
                        RS <CheckCSName csName={r.cross_section} csNameVal={r.cross_section} />
                    </ResultHeaderCell>
                    <ResultHeaderCell colSpan={2}>US</ResultHeaderCell>
                    <ResultHeaderCell colSpan={2}>DS</ResultHeaderCell>
                </ResultRow>
                <ResultRow>
                    <ResultHeaderCell style={{
                        textAlign: 'right',
                        width: HecRasHelper.getWidth(8)
                    }}>Left</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        textAlign: 'right',
                        width: HecRasHelper.getWidth(8)
                    }}>Right</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        textAlign: 'right',
                        width: HecRasHelper.getWidth(8)
                    }}>Left</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        textAlign: 'right',
                        width: HecRasHelper.getWidth(8)
                    }}>Right</ResultHeaderCell>
                </ResultRow>
            </ResultHeader>
            <ResultBody>
                <ResultRow>
                    <ResultBodyCell>Bank Sta</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.us_bank_left?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.us_bank_right?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.ds_bank_left?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.ds_bank_right?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Bank Elev</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.us_bank_left_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.ds_bank_left_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.us_bank_right_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.ds_bank_right_elev?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Ineff Sta</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'right'}}>
                        <SuperText text={r.up_left_xs_footnote}/>
                        {r.up_left_xs_station?.toString() || '-'}
                    </ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'right'}}>
                        <SuperText text={r.up_right_xs_footnote}/>
                        {r.up_right_xs_station?.toString() || '-'}
                    </ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'right'}}>
                        <SuperText text={r.down_left_xs_footnote}/>
                        {r.down_left_xs_station?.toString() || '-'}
                    </ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'right'}}>
                        <SuperText text={r.down_right_xs_footnote}/>
                        {r.down_right_xs_station?.toString() || '-'}
                    </ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Ineff Elev</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.up_left_xs_station_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.up_right_xs_station_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.down_left_xs_station_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.down_right_xs_station_elev?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Opening Sta</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.us_left_opening_sta?.toFixed(2) || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.us_right_opening_sta?.toFixed(2) || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.ds_left_opening_sta?.toFixed(2) || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.ds_right_opening_sta?.toFixed(2) || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Dist. Btw XS</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'right'}}
                                    colSpan={4}>{r?.us_dist_btw_xs?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Expansion Width</ResultBodyCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.up_left_diff?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.up_right_diff?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.down_left_diff?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.down_right_diff?.toString() || '-'}</ResultHeaderCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Cont/Exp Ratio</ResultBodyCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.up_left_ratio?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.up_right_ratio?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.down_left_ratio?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.down_right_ratio?.toString() || '-'}</ResultHeaderCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Lowest High Chord Elev</ResultBodyCell>
                    <ResultBodyCell
                        colSpan={2}
                        style={{textAlign: 'right'}}>{r.us_low_high_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        colSpan={2}
                        style={{textAlign: 'right'}}>{r.ds_low_high_elev?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Lowest High Chord Sta</ResultBodyCell>
                    <ResultBodyCell
                        colSpan={2}
                        style={{textAlign: 'right'}}>{r.us_low_high_sta?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        colSpan={2}
                        style={{textAlign: 'right'}}>{r.ds_low_high_sta?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                {culverts}
            </ResultBody>
        </ResultTable>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.INF01.error_id: {
            return (
                <>
                    <ResultText>
                        The following structure geometry data is extracted from the model files. They are used for
                        relevant
                        checks, comparisons, and plots.
                        <EmptyLine/>
                    </ResultText>
                    {
                        row.data?.map(r => {
                            if (r.type === 'Bridge') {
                                return (
                                    <>
                                        <BridgeTable r={r}/>
                                        <EmptyLine height={12}/>
                                    </>
                                )
                            } else if (r.type === 'Culvert') {
                                return (
                                    <>
                                        <CulvertTable r={r}/>
                                        <EmptyLine height={12}/>
                                    </>
                                )
                            }
                        })
                    }
                    <EmptyLine height={16}/>
                    <div style={{fontSize: '8pt', paddingLeft: 8}}>
                        <div><SuperText text={'1'}/> XS Ineff is not defined. Start Station is used for
                            calculation.
                        </div>
                        <div><SuperText text={'2'}/> XS Ineff is not defined. End Station is used for
                            calculation.
                        </div>
                    </div>
                </>
            )
        }
        case MessageCodes.Internal.ST1_ST12.error_id: {
            return (
                <>
                    <ResultText>
                        The upstream and downstream abutment slopes (V:H) are tabulated at the following {row?.data?.length} bridges. Inconsistencies are highlighted in red text.
                    </ResultText>
                    <EmptyLine/>
                    {
                        row?.data?.map(r => {
                            const left = []
                            const right = []

                            r?.abutment_left?.us?.forEach((x, idx) => {
                                left.push([x, r?.abutment_left?.ds[idx]])
                            })

                            r?.abutment_right?.us?.forEach((x, idx) => {
                                right.push([x, r?.abutment_right?.ds[idx]])
                            })
                            return (
                                <>
                                    <ResultTable>
                                        <ResultHeader>
                                            <ResultRow>
                                                <ResultHeaderCell rowSpan={2} style={{
                                                    width: HecRasHelper.getWidth(12),
                                                    textAlign: 'start'
                                                }}>
                                                    Bridge at <CheckCSName csName={r?.cross_section}/>
                                                </ResultHeaderCell>
                                                <ResultHeaderCell colSpan={3} style={{
                                                    textAlign: 'center',
                                                    width: HecRasHelper.getWidth(24)
                                                }}>US</ResultHeaderCell>
                                                <ResultHeaderCell colSpan={3} style={{
                                                    textAlign: 'center',
                                                    width: HecRasHelper.getWidth(24)
                                                }}>DS</ResultHeaderCell>
                                            </ResultRow>
                                            <ResultRow>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Station</ResultHeaderCell>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Elevation</ResultHeaderCell>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Slope</ResultHeaderCell>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Station</ResultHeaderCell>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Elevation</ResultHeaderCell>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Slope</ResultHeaderCell>
                                            </ResultRow>
                                        </ResultHeader>
                                        <ResultBody>
                                            {
                                                left?.map((x, idx) => (
                                                    <ResultRow>
                                                        {idx === 0 && (<ResultBodyCell
                                                            rowSpan={left?.length}>Left</ResultBodyCell>)}
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end'
                                                        }}>{x[0]?.station}</ResultBodyCell>
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end'
                                                        }}>{x[0]?.elev}</ResultBodyCell>
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end',
                                                            color: x[0]?.slope !== x[1]?.slope ? 'red' : ''
                                                        }}>{x[0]?.slope?.toFixed(2)}</ResultBodyCell>
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end'
                                                        }}>{x[1]?.station}</ResultBodyCell>
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end'
                                                        }}>{x[1]?.elev}</ResultBodyCell>
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end',
                                                            color: x[0]?.slope !== x[1]?.slope ? 'red' : ''
                                                        }}>{x[1]?.slope?.toFixed(2)}</ResultBodyCell>
                                                    </ResultRow>
                                                ))
                                            }
                                            {
                                                right?.map((x, idx) => (
                                                    <ResultRow>
                                                        {idx === 0 && (<ResultBodyCell
                                                            rowSpan={right?.length}>Right</ResultBodyCell>)}
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end'
                                                        }}>{x[0]?.station}</ResultBodyCell>
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end'
                                                        }}>{x[0]?.elev}</ResultBodyCell>
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end',
                                                            color: x[0]?.slope !== x[1]?.slope ? 'red' : ''
                                                        }}>{x[0]?.slope?.toFixed(2)}</ResultBodyCell>
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end'
                                                        }}>{x[1]?.station}</ResultBodyCell>
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end'
                                                        }}>{x[1]?.elev}</ResultBodyCell>
                                                        <ResultBodyCell style={{
                                                            width: HecRasHelper.getWidth(8),
                                                            textAlign: 'end',
                                                            color: x[0]?.slope !== x[1]?.slope ? 'red' : ''
                                                        }}>{x[1]?.slope?.toFixed(2)}</ResultBodyCell>
                                                    </ResultRow>
                                                ))
                                            }
                                        </ResultBody>
                                    </ResultTable>
                                    <EmptyLine/>
                                </>
                            )
                        })
                    }
                </>
            )
        }
    }
}